import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>About Cargo Engage - Lead Generation Company | CARGO AUTOMOTIVE SERVICES INC</title>
        <meta name="description" content="Learn about CARGO AUTOMOTIVE SERVICES INC (DBA: Cargo Engage). We are a professional lead generation company connecting consumers with financial service providers. EIN: 83-2229681." />
        <meta name="keywords" content="Cargo Engage, CARGO AUTOMOTIVE SERVICES INC, lead generation company, financial services, Monroe NY, Mendel Friedman" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">About Cargo Engage</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <div style={{background: '#fff3cd', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ffc107'}}>
              <p style={{fontWeight: '600', color: '#856404', marginBottom: '0.5rem'}}>
                Important Disclosure:
              </p>
              <p style={{color: '#856404'}}>
                CARGO AUTOMOTIVE SERVICES INC (operating as Cargo Engage) is a lead generation and marketing company. We are NOT a lender and do NOT make credit decisions. 
                We connect consumers with financial service providers.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Who We Are</h2>
            <p style={{marginBottom: '2rem'}}>
              CARGO AUTOMOTIVE SERVICES INC, operating as Cargo Engage, is a professional lead generation company specializing in connecting consumers seeking financial 
              services with our network of trusted lending partners. Founded with a commitment to compliance and quality, 
              we help bridge the gap between consumers' financial needs and the providers who can meet them.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Our Mission</h2>
            <p style={{marginBottom: '2rem'}}>
              Our mission is to provide high-quality, compliant lead generation services that benefit both consumers and 
              financial service providers. We strive to connect consumers with the right lending partners while maintaining 
              the highest standards of compliance, privacy, and customer service.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>What We Do</h2>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Generate qualified leads for financial service providers</li>
              <li>Connect consumers with appropriate lending partners</li>
              <li>Provide compliant SMS and email marketing services</li>
              <li>Manage lead qualification and verification processes</li>
              <li>Ensure all activities comply with TCPA, CTIA, and financial regulations</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Our Commitment to Compliance</h2>
            <p style={{marginBottom: '1rem'}}>
              Compliance is at the core of everything we do. We maintain strict adherence to:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>TCPA (Telephone Consumer Protection Act):</strong> All communications require express written consent</li>
              <li><strong>CTIA Guidelines:</strong> SMS programs follow all carrier and industry standards</li>
              <li><strong>Privacy Regulations:</strong> Consumer data is protected and never sold to third parties</li>
              <li><strong>Financial Services Regulations:</strong> Clear disclosures about our role as a lead generator</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Business Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>Legal Name:</strong> CARGO AUTOMOTIVE SERVICES INC</p>
              <p><strong>DBA:</strong> Cargo Engage</p>
              <p><strong>EIN:</strong> 83-2229681</p>
              <p><strong>Address:</strong> 306 Schunnemunk Street, Monroe, NY 10950</p>
              <p><strong>Owner:</strong> Mendel Friedman</p>
              <p><strong>Business Type:</strong> Lead Generation & Marketing Services</p>
              <p><strong>Industry:</strong> Financial Services Lead Generation</p>
            </div>

            <div style={{marginTop: '3rem', textAlign: 'center'}}>
              <Link to="/contact" style={{
                background: '#1e3c72',
                color: 'white',
                padding: '12px 30px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                display: 'inline-block'
              }}>Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
